import { createAction, props } from '@ngrx/store';
import {
  ITemplateDataCriteria,
  IDefaultTasksForTemplateCriteria,
  ITemplateTypeCriteria,
} from '../types/fandc-generator.types';
import {
  IGeneratedTask,
  IGeneratedTasksModel,
} from '../../../../modules/tasks/model/types';
import { Frequency, FrequencyOffsetOption } from '../services/frequencyoptions.service';

// Fetch Template Types
export const fetchTemplateTypes = createAction(
  '[FandC] Fetch TemplateTypes',
  props<{ criteria: ITemplateTypeCriteria }>()
);
export const fetchTemplateTypesSuccess = createAction(
  '[FandC] Fetch TemplateTypes Success',
  props<{ data: any[] }>()
);

// Fetch Templates
export const fetchTemplates = createAction(
  '[FandC] Fetch Templates',
  props<{ criteria: ITemplateDataCriteria }>()
);
export const fetchTemplatesSuccess = createAction(
  '[FandC] Fetch Templates Success',
  props<{ data: any[] }>()
);

// Fetch Default Tasks
export const fetchDefaultTasksForTemplate = createAction(
  '[FandC] Fetch Default Tasks For Template',
  props<{ criteria: IDefaultTasksForTemplateCriteria }>()
);

export const fetchDefaultTasksForTemplateSuccess = createAction(
  '[FandC] Fetch Default Tasks For Template Success',
  props<{ data: any }>()
);

// Fetch Generated Tasks
export const fetchGeneratedTasks = createAction(
  '[FandC] Fetch Generated Tasks',
  props<{ model: IGeneratedTasksModel }>()
);
export const fetchGeneratedTasksSuccess = createAction(
  '[FandC] Fetch Generated Tasks Success',
  props<{ tasks: IGeneratedTask[] }>()
);

export const saveGeneratedTasks = createAction('[FandC] Save Generated Tasks');

export const saveGeneratedTasksSuccess = createAction(
  '[FandC] Save Generated Tasks Success',
  props<{ data: any[] }>()
);

export const updateSelectedDefaultTasks = createAction(
  '[FandC] Update Prototype Task',
  props<{ data: string[] }>()
);

export const setReferenceDate = createAction(
  '[FandC] Set ReferenceDate',
  props<{ selectedReferenceDate: Date }>()
);

export const setMaturityDate = createAction(
  '[FandC] Set MaturityDate',
  props<{ selectedMaturityDate: Date }>()
);

export const setFrequency = createAction(
  '[FandC] Set Frequency',
  props<{ selectedFrequency: Frequency }>()
);

export const fetchFrequencyOptions = createAction('[FandC] Fetch Frequency Options');

export const setFrequencyOptions = createAction(
  '[FandC] Set Frequency Options',
  props<{ options: Frequency[] }>()
);

export const fetchFormatOptions = createAction('[FandC] Fetch Format Options');

export const setFormatOptions = createAction(
  '[FandC] Set Format Options',
  props<{ options: string[] }>()
);
export const setFormatOption = createAction('[FandC] Set Format Option',
  props<{ selectedFormatOption: string | null }>()
);

export const setFrequencyOffsetValue = createAction(
  '[FandC] Set Frequency Offset Value',
  props<{ selectedFrequencyOffsetValue: string | null }>()
);

export const setFrequencyOffsetOptions = createAction(
  '[FandC] Set Frequency Offset Options',
  props<{ options: FrequencyOffsetOption[] }>()
);

export const updatePrototypeTasks = createAction(
  '[FandC] Update Prototype Tasks',
  props<{ changeData: any }>()
);

export const generateTasks = createAction('[FandC] Generate Tasks');

export const updateGeneratedTasks = createAction(
  '[FandC] Update Generated Tasks',
  props<{ changeData: any }>()
);

export const fetchLoans = createAction('[FandC] Fetch Loans');

export const fetchLoansSuccess = createAction(
  '[FandC] Fetch Loans Success',
  props<{ data: any[] }>()
);

export const setLoanNumber = createAction(
  '[FandC] Set Loan Number',
  props<{ selectedLoan: { id: string, name: string } }>()
);

export const fetchLoanDetail = createAction('[FandC] Fetch Loan Detail', props<{ facilityId: string }>());

export const fetchLoanDetailSuccess = createAction(
  '[FandC] Fetch Loan Detail Success',
  props<{ data: any }>()
);

export const setLoanDetail = createAction(
  '[FandC] Set Loan Detail',
  props<{ loanDetail: any }>()
);

export const setSelectedTemplateType = createAction(
  '[FandC] Set Template Type',
  props<{ templateType: string }>()
);
export const setCategory = createAction(
  '[FandC] Set Category',
  props<{ category: string }>()
);
export const setTasks = createAction(
  '[FandC] Set Tasks',
  props<{ tasks: any[] }>()
);
export const resetFandCGenerator = createAction('[FandC] Reset');

export const setFirstDueDate = createAction(
  '[FandC] Set First Due Date',
  props<{ firstDueDate: Date | null }>()
);

export const fetchReportEntityOptions = createAction('[FandC] Fetch Report Entity Options');

export const fetchReportEntityOptionsSuccess = createAction(
  '[FandC] Fetch Report Entity Options Success',
  props<{ data: any }>()
);

export const setReportEntity = createAction(
  '[FandC] Set Report Entity',
  props<{ selectedReportEntity: string | null }>()
);

export const setEntityNameOptions = createAction(
  '[FandC] Set Entity Name Options',
  props<{ options: { label: string; value: string }[] }>()
);

export const setEntityName = createAction(
  '[FandC] Set Entity Name',
  props<{ selectedEntityName: string | null }>()
);

export const saveGenerationTask = createAction('[FandC] Save Generation Task');

export const saveGenerationTaskSuccess = createAction(
  '[FandC] Save Generation Task Success',
  props<{ data: any }>()
);

export const saveGenerationMetadata = createAction('[FandC] Save Generation Metadata');

export const saveGenerationMetadataSuccess = createAction(
  '[FandC] Save Generation Metadata Success',
  props<{ metadata: any }>()
);

export const fetchGenerationMetadata = createAction(
  '[FandC] Fetch Generation Metadata',
  props<{ metadataId: string }>()
);

export const fetchGenerationMetadataSuccess = createAction(
  '[FandC] Fetch Generation Metadata Success',
  props<{ metadata: any }>()
);

export const fetchRootTemplate = createAction(
  '[FandC] Fetch Root Template',
  props<{ templateName: string | null }>()
);

export const fetchRootTemplateSuccess = createAction(
  '[FandC] Fetch Root Template Success',
  props<{ data: any }>()
);

export const addToSelectedPrototypeTasks = createAction('[FandC] Add To Selected Prototype Tasks');

export const removePrototypeTask = createAction(
  '[FandC] Remove Prototype Task',
  props<{ rowId: string }>()
);

export const setSelectedPrototypeTasks = createAction(
  '[FandC] Set Selected Prototype Tasks',
  props<{ selectedPrototypeTasks: any[] }>()
);

export const setTaskId = createAction(
  '[FandC] Set TaskId',
  props<{ taskId: string | null }>()
);

export const setTaskGenerationMetadataId = createAction(
  '[FandC] Set TaskGenerationMetadataId',
  props<{ taskGenerationMetadataId: string | null }>()
);

export const setExistingTaskIds = createAction(
  '[FandC] Set Existing Task Ids',
  props<{ existingTaskIds: string[] }>()
);

export const updateBatch = createAction('[FandC] Update Batch');

export const updateBatchSuccess = createAction(
  '[FandC] Update Batch Success',
  props<{ data: any }>()
);

export const clearEditModeFormSelections = createAction(
  '[FandC] Clear Edit Mode Form Selections'
);

export const fetchReviewers = createAction('[FandC] Fetch Reviewers');

export const fetchReviewersSuccess = createAction(
  '[FandC] Fetch Reviewers Success',
  props<{ reviewers: { id: string; name: string }[] }>()
);

export const setReviewer = createAction(
  '[FandC] Set Reviewer',
  props<{ reviewerId: string | null; reviewerName: string | null }>()
);


